import React, { useState } from 'react';
import { GOLD, BLACK } from '../constants/theme';
import { EJS_PUBLIC_KEY, EJS_SERVICE_ID, EJS_TEMPLATE_ID } from '../constants/emailjs';
import SecLabel from './ui/SecLabel';
import GoldBtn from './ui/GoldBtn';

type Status = 'idle' | 'sending' | 'success' | 'error';

declare global {
  interface Window { emailjs: any; }
}

const Contact: React.FC = () => {
  const [f, setF] = useState({ name:'', email:'', phone:'', event:'', date:'', guests:'', msg:'' });
  const [status, setStatus] = useState<Status>('idle');
  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) =>
    setF(p => ({ ...p, [k]: e.target.value }));

  const sendEmail = async () => {
    if (!f.name || !f.email) { setStatus('error'); return; }
    setStatus('sending');
    try {
      if (!window.emailjs) {
        await new Promise<void>((res, rej) => {
          const s = document.createElement('script');
          s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
          s.onload = () => res(); s.onerror = () => rej();
          document.head.appendChild(s);
        });
        window.emailjs.init({ publicKey: EJS_PUBLIC_KEY });
      }
      await window.emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE_ID, {
        from_name:       f.name,
        from_email:      f.email,
        phone:           f.phone,
        event_type:      f.event,
        event_date:      f.date,
        number_of_guests: f.guests,
        message:         f.msg,
        reply_to:        f.email,
      });
      setStatus('success');
      setF({ name:'', email:'', phone:'', event:'', date:'', guests:'', msg:'' });
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus('error');
    }
  };

  const inp: React.CSSProperties = {
    background:'rgba(255,255,255,0.04)',
    border:'1px solid rgba(196,152,50,0.22)',
    color:'#fff', fontFamily:'Montserrat', fontSize:12,
    padding:'13px 16px', width:'100%', outline:'none', transition:'border 0.3s',
  };
  const focus = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) =>
    (e.target.style.borderColor = GOLD);
  const blur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) =>
    (e.target.style.borderColor = 'rgba(196,152,50,0.22)');

  return (
    <section id="contact" style={{ background:BLACK, padding:'90px 8vw' }}>
      <SecLabel text="GET IN TOUCH"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,3.6vw,48px)', fontWeight:300, color:'#fff', textAlign:'center', marginTop:6 }}>
        Plan Your <em style={{ color:GOLD }}>Event With Us</em>
      </h2>

      {/* <div style={{ background:'rgba(196,152,50,0.08)', border:'1px solid rgba(196,152,50,0.28)', borderRadius:2, padding:'12px 20px', maxWidth:700, margin:'24px auto 0', textAlign:'center' }}>
        <p style={{ fontFamily:'Montserrat', fontSize:10, color:GOLD, letterSpacing:1 }}>
          ⚙️ Replace <strong>EJS_PUBLIC_KEY</strong>, <strong>EJS_SERVICE_ID</strong> &amp; <strong>EJS_TEMPLATE_ID</strong> in <code>src/constants/emailjs.ts</code> with your <a href="https://www.emailjs.com" target="_blank" rel="noreferrer" style={{ color:GOLD }}>EmailJS</a> credentials.
        </p>
      </div> */}

      <div style={{ display:'flex', gap:52, marginTop:52, flexWrap:'wrap' }}>
        {/* Info */}
        <div style={{ flex:'1 1 240px' }}>
          {([
            ['📍','Address','Mangalore, Udupi & Manipal'],
            ['📞','Phone','+91 6363346589\n+91 8123348118'],
            ['✉️','Email','gowjeecaterers@gmail.com'],
            // ['🕐','Hours','Mon–Sat: 9 AM – 8 PM\nSunday: 10 AM – 5 PM'],
          ] as const).map(([ic,lb,val]) => (
            <div key={lb} style={{ display:'flex', gap:16, marginBottom:26 }}>
              <div style={{ width:42, height:42, border:`1px solid ${GOLD}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, flexShrink:0 }}>{ic}</div>
              <div>
                <div style={{ fontFamily:'Montserrat', fontSize:9, letterSpacing:2, color:GOLD, textTransform:'uppercase', marginBottom:4 }}>{lb}</div>
                <div style={{ fontFamily:'Montserrat', fontSize:11, color:'rgba(255,255,255,0.6)', lineHeight:1.75, whiteSpace:'pre-line' }}>{val}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Form */}
        <div style={{ flex:'2 1 360px' }}>
          {status === 'success' ? (
            <div style={{ textAlign:'center', padding:'52px 0' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>✅</div>
              <h3 style={{ fontFamily:'Cormorant Garamond', fontSize:28, color:GOLD }}>Message Sent!</h3>
              <p style={{ fontFamily:'Montserrat', fontSize:12, color:'rgba(255,255,255,0.62)', marginTop:10 }}>Thank you! We'll be in touch shortly.</p>
              <div style={{ marginTop:24 }}><GoldBtn onClick={() => setStatus('idle')}>Send Another</GoldBtn></div>
            </div>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
              <div><input placeholder="Your Name *" value={f.name} onChange={set('name')} style={inp} onFocus={focus} onBlur={blur}/></div>
              <div><input type="email" placeholder="Email Address *" value={f.email} onChange={set('email')} style={inp} onFocus={focus} onBlur={blur}/></div>
              <div><input placeholder="Phone Number" value={f.phone} onChange={set('phone')} style={inp} onFocus={focus} onBlur={blur}/></div>
              <div>
                <select value={f.event} onChange={set('event')} style={{ ...inp, appearance:'none', cursor:'pointer' }} onFocus={focus} onBlur={blur}>
                  <option value="" style={{ background:BLACK }}>Event Type</option>
                  {['Wedding','Corporate Event','Birthday Party','Cocktail Event','Outdoor Event','Other'].map(o => (
                    <option key={o} value={o} style={{ background:BLACK }}>{o}</option>
                  ))}
                </select>
              </div>
              <div><input type="date" value={f.date} onChange={set('date')} style={inp} onFocus={focus} onBlur={blur}/></div>
              <div><input type="number" min={1} placeholder="Number of Guests" value={f.guests} onChange={set('guests')} style={inp} onFocus={focus} onBlur={blur}/></div>
              <div style={{ gridColumn:'1/-1' }}>
                <textarea placeholder="Tell us about your event — guest count, venue, special requirements…" value={f.msg} onChange={set('msg')} rows={5} style={{ ...inp, resize:'vertical' }} onFocus={focus} onBlur={blur}/>
              </div>
              {status === 'error' && (
                <div style={{ gridColumn:'1/-1' }}>
                  <p style={{ fontFamily:'Montserrat', fontSize:10, color:'#e55', letterSpacing:1 }}>
                    {!f.name || !f.email ? '⚠ Please fill in Name and Email.' : '⚠ Failed to send. Check your EmailJS credentials.'}
                  </p>
                </div>
              )}
              <div style={{ gridColumn:'1/-1' }}>
                <GoldBtn full outline={false} disabled={status==='sending'} onClick={sendEmail}>
                  {status === 'sending' ? 'Sending…' : 'Send Enquiry'}
                </GoldBtn>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;